// Estado global de autenticación (perfil del usuario local). Ver CLAUDE.md §12.
import { create } from 'zustand'
import type { User } from '@/types'

interface AuthState {
  user: User | null
  isLoading: boolean
  setUser: (user: User | null) => void
  setLoading: (loading: boolean) => void
  hasRole: (...roles: User['role'][]) => boolean
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isLoading: true,
  setUser: (user) => set({ user, isLoading: false }),
  setLoading: (isLoading) => set({ isLoading }),
  hasRole: (...roles) => {
    const role = get().user?.role
    return role != null && roles.includes(role)
  },
}))
